<template>
<div id="app">
  <div id="sidebarsticky" v-bind:class="{ isvisible: stickysidebar === true, ishidden: stickysidebar === false }" class="sticky-sidebar d-none d-sm-block d-md-block d-lg-block">
    <div class="container" v-bind:class="{ isvisible: stickysidebar === true, ishidden: stickysidebar === false }">
      <div class="sidebar_button button1" @click="setmodalvoucherrequest()">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fa fa-gift"></i>
          </div>
        </div>
      </div>
      <div class="sidebar_button button1" @click="phone()">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fa fa-phone"></i>
          </div>
        </div>
      </div>
      <div class="sidebar_button button2" @click="mail()">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fa fa-at"></i>
          </div>
        </div>
      </div>
      <div class="sidebar_button button3" @click="setmodalgeneralrequest('Probetraining');">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fa fa-comment"></i>
          </div>
        </div>
      </div>
      <div class="sidebar_button button4" @click="whatsapp()">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fab fa-whatsapp"></i>
          </div>
        </div>
      </div>
      <div v-if="selectedevents.length > 0" class="sidebar_button button5" @click="setmodalshoppingcart()">
        <div class="row d-flex h-100">
          <div class="align-middle mx-auto justify-content-center align-self-center">
            <i class="fa fa-shopping-cart"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer id="fadein" v-bind:class="{ isvisible: stickysidebar === true, ishidden: stickysidebar === false }" class="footer show d-sm-none d-md-none d-lg-none">
    <nav class="navbar fixed-bottom navbar-expand-sm">
      <ul class="navbar-nav col-12 d-flex flex-row justify-content-between">
        <li class="nav-item p-2 active" @click="setmodalvoucherrequest()">
          <a class="nav-link" href="#">
            <i class="fa fa-lg fa-align-center fa-gift"></i>
            <span>Gutschein</span>
          </a>
        </li>
        <li class="nav-item p-2 active" @click="phone()">
          <a class="nav-link" href="#">
            <i class="fa fa-lg fa-align-center fa-phone-alt"></i>
            <span>Telefon</span>
          </a>
        </li>
        <li class="nav-item p-2 active" @click="mail($event)">
          <a class="nav-link" href="#">
            <i class="fa fa-lg fa-align-center fa-at"></i>
            <span>Mail</span>
          </a>
        </li>
        <li class="nav-item p-2 active" @click="setmodalgeneralrequest('Probetraining');">
          <a class="nav-link" href="#">
            <i class="fa fa-lg fa-align-center fa-comment"></i>
            <span>Kontakt</span>
          </a>
        </li>
        <li class="nav-item p-2 active" @click="whatsapp()">
          <a class="nav-link" href="#">
            <i class="fab fa-lg fa-align-center fa-whatsapp"></i>
            <span>WhatsApp</span>
          </a>
        </li>
        <li v-if="selectedevents.length > 0" class="nav-item p-2 active" @click="setmodalshoppingcart();" v-bind:class="{ isvisible: showshoppingcart === true, ishidden: showshoppingcart === false }">
          <a class="nav-link" href="#">
            <i class="fa fa-lg fa-align-center fa-shopping-cart"></i>
            <span>Warenkorb</span>
          </a>
        </li>
      </ul>
    </nav>
  </footer>
  <div class="sticky-chat-button" v-if="false">
    <div class="circle" style="animation-delay: -3s"></div>
    <div class="circle" style="animation-delay: -2s"></div>
    <div class="circle" style="animation-delay: -1s"></div>
    <div class="circle" style="animation-delay: 0s"></div>
  </div>
  <nav v-show="showstickynavbar" data-navigationidname="sp-header" class="site-header py-1" id="persitentnav">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6" style="color:#ffffff !important;">
          <h3 style="margin-top: 6px;">Inhaltsübersicht</h3>
        </div>
        <div id="stickyhorizontalnav" class="containernav col-12 col-sm-6 d-flex flex-row justify-content-between">
        </div>
      </div>
    </div>
  </nav>
  <modal title="" large :show.sync="showmodalgeneralrequest" :value="showmodalgeneralrequest" @ok="closemodal()" @cancel="closemodal()" effect="fade/zoom">
    <div slot="modal-header" class="modal-header" style="min-height: 62px;">
      <h4 class="modal-title">{{ showmodalgeneralrequestmodus }} anfragen</h4>
      <button type="button" class="btn btn-secondary align-right" @click="closemodal()">X</button>
    </div>
    <div slot="modal-body" class="modal-body" style="background-color: #eaeaea;" v-if="done === false" data-vv-scope="request">
      <form data-vv-scope="request">
        <div class="form-row">
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('request.forename') }" name="forename" aria-describedby="forenameHelp" placeholder="Vorname" v-model="dataset.forename">
            <span class="help is-danger" v-show="errors.has('request.forename')">Bitte gib Deinen Vornamen ein.</span>
          </div>
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('request.surname') }" name="surname" aria-describedby="surnameHelp" placeholder="Nachname" v-model="dataset.surname">
            <span class="help is-danger" v-show="errors.has('request.surname')">Bitte gib Deinen Nachnamen ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="number" v-validate="'required|numeric'" :class="{'form-control': true, 'is-danger': errors.has('request.telephon') }" name="telephon" aria-describedby="telephonHelp" placeholder="Telefonnummer" v-model="dataset.telephone">
            <span class="help is-danger" v-show="errors.has('request.telephon')">Bitte gib Deine Telefonnummer ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="email" v-validate="'required|email'" :class="{'form-control': true, 'is-danger': errors.has('request.mail') }" name="mail" aria-describedby="forenameHelp" placeholder="Email" v-model="dataset.email">
            <span class="help is-danger" v-show="errors.has('request.mail')">Bitte gib Deine Emailadresse ein.</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <h5>Wofür interessierst Du Dich?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div v-for="training in trainings" class="form-check col-md-6 col-6">
                <label class="checkcontainer" :for=training.training>{{ training.training }}
                  <input type="checkbox" :id=training.training :value=training.training v-model="trainingsobj">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Was möchtest Du zuerst tun?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-check col-md-6 col-6">
                <label class="radiocontainer" for="consultation">Beratungs&shy;gespräch
                  <input id="consultation" type="radio" value="Beratungsgespräch" v-model="modus">
                  <span class="radiocheckmark"></span>
                </label>
              </div>
              <div class="form-check col-md-6 col-6">
                <label class="radiocontainer" for="trailpractice">Probe&shy;training
                  <input id="trailpractice" type="radio" value="Probetraining" v-model="modus">
                  <span class="radiocheckmark"></span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12">
                <label for="comment">Bemerkung</label>
                <textarea class="form-control" rows="5" v-model="notice"></textarea>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row" style="margin-top:24px;">
          <div class="col-sm-12">
            <h5>Wann passt es?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="form-row">
              <div class="col-md-12">
                <ul class="list-group">
                  <li class="list-group-item" v-for="(date,i) in dates" style="background-color: #eaeaea; margin-bottom: 24px;">
                    <div class="row">
                      <div class="col-12 col-sm-5">
                        <v-date-picker v-model="date.date" mode="single" class="multiselect__input col-12" :min-date=mindate() :disabled-dates=getdisableddays(i) visibility="focus" wrapper="{ backgroundColor: '#fafafa'; border: '1px solid #dadada'; width: 100%; }"></v-date-picker>
                      </div>
                      <div class="col-10 col-sm-5">
                        <multiselect v-model="date.times" :multiple="true" selectLabel="" track-by="time" label="time" :options="times" :close-on-select="false" :searchable="false" :internal-search="false" :hide-selected="true" :clear-on-select="false" placeholder="Zeit">
                        </multiselect>
                      </div>
                      <div class="col-2 col-sm-2">
                        <button class="btn btn-info" type="button" @click="deletedate(i)">X</button>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-sm-8 col-xs-12">
                <button type="button" class="btn btn-large btn-block btn-outline-success" @click="adddate()">Datum und Uhrzeiten hinzufügen</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div slot="modal-body" class="modal-body" v-if="done === true" style="min-height: 400px;">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="align-middle">Vielen Dank für Deine Anfrage. Wir melden uns umgehend bei Dir.</h1>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer" style="display: inline;" data-vv-scope="request">
      <form data-vv-scope="request">
        <div class="container-fluid">
          <div class="row" v-if="done === false">
            <div class="col-12 col-md-12">
              <label class="checkcontainer">Hiermit erkläre ich mich mit der <strong><a href="https://www.b2-fit.de/datenschutz" target="_blank">Datenschutzerklärung</a></strong> einverstanden.
                <input name="datenschutzrequest" id="datenschutzrequest" type="checkbox" v-validate="'required'" value="Datenschutzakzeptiert">
                <span class="checkmark" :class="{'is-danger': errors.has('request.datenschutzrequest') }"></span>
                <span class="help is-danger" v-show="errors.has('request.datenschutzrequest')">Bitte akzeptiere unsere Datenschutzhinweise.<br/></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 span12 btn-block" v-if="done === false">
              <button class="btn btn-large btn-block btn-primary" type="button" @click="submitform()" style="background-image: linear-gradient(-60deg,#429321 0%,#B4EC51 100%) !important;border: 0px !important;">{{ showmodalgeneralrequestmodus }} anfragen</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center" style="font-size: 10px; padding-top: 24px;">Powered by mycrogym.com</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
  <modal title="" large :show.sync="showmodalcourserequest" :value="showmodalcourserequest" @ok="closemodalcourserequest()" @cancel="closemodalcourserequest()" effect="fade/zoom">
    <div slot="modal-header" class="modal-header">
      <h4 class="modal-title">{{ showmodalcourserequestname }} anfragen</h4>
      <button type="button" class="btn btn-secondary align-right" @click="closemodalcourserequest()">X</button>
    </div>
      <div slot="modal-body" class="modal-body" style="background-color: #eaeaea;" v-if="done === false">
        <form data-vv-scope="courserequest">
          <div class="form-row">
            <div class="form-group col-sm-6 col-xs-12">
              <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('courserequest.forename') }" name="forename" aria-describedby="forenameHelp" placeholder="Vorname" v-model="dataset.forename">
              <span class="help is-danger" v-show="errors.has('courserequest.forename')">Bitte gib Deinen Vornamen ein.</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('courserequest.surname') }" name="surname" aria-describedby="surnameHelp" placeholder="Nachname" v-model="dataset.surname">
              <span class="help is-danger" v-show="errors.has('courserequest.surname')">Bitte gib Deinen Nachnamen ein.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12">
              <input type="number" v-validate="'required|numeric'" :class="{'form-control': true, 'is-danger': errors.has('courserequest.telephon') }" name="telephon" aria-describedby="telephonHelp" placeholder="Telefonnummer" v-model="dataset.telephone">
              <span class="help is-danger" v-show="errors.has('courserequest.telephon')">Bitte gib Deine Telefonnummer ein.</span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-sm-12">
              <input type="email" v-validate="'required|email'" :class="{'form-control': true, 'is-danger': errors.has('courserequest.mail') }" name="mail" aria-describedby="forenameHelp" placeholder="Email" v-model="dataset.email">
              <span class="help is-danger" v-show="errors.has('courserequest.mail')">Bitte gib Deine Emailadresse ein.</span>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12">
              <h5>{{ showmodalcourserequestname }}</h5>
            </div>
          </div>
          <div class="card">
            <div :class="{'card-body': true, 'is-danger': errors.has('courserequest.modus2') }">
              <div class="row">
                <div class="form-check col-md-6 col-6">
                  <label class="radiocontainer" for="consultation2" key="Kursstart_vereinbaren">Start ver&shy;ein&shy;bar&shy;en
                    <input id="consultation2" type="radio" value="Kursstart_vereinbaren" v-model="modus2">
                    <span class="radiocheckmark"></span>
                  </label>
                </div>
                <div class="form-check col-md-6 col-6">
                  <label class="radiocontainer" for="consultationappointment" key="Beratungsgespräch_anfragen">Berat&shy;ungs&shy;ge&shy;spräch an&shy;frag&shy;en
                    <input id="consultationappointment" type="radio" value="Beratungsgespräch_anfragen" v-model="modus2">
                    <span class="radiocheckmark"></span>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label for="comment">Bemerkung</label>
                  <textarea class="form-control" rows="5" v-model="notice"></textarea>
                </div>
              </div>
            </div>
          </div>
          <br />
        </form>
      </div>
      <div slot="modal-body" class="modal-body" v-if="done === true" style="min-height: 400px;">
        <div class="row align-items-center">
          <div class="col">
            <h1 class="align-middle">Vielen Dank für Deine Anfrage. Wir melden uns umgehend bei Dir.</h1>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="modal-footer" style="display: inline;">
        <form data-vv-scope="courserequest">
          <div class="container-fluid">
            <div class="row" v-if="done === false">
              <div class="col-12 col-md-12">
                <label class="checkcontainer">Hiermit erkläre ich mich mit der <strong><a href="https://www.b2-fit.de/datenschutz" target="_blank">Datenschutzerklärung</a></strong> einverstanden.
                  <input name="datenschutzbp" id="datenschutzbp" type="checkbox" v-validate="'required'" value="Datenschutzakzeptiert" v-model="dataprivacy">
                  <span class="checkmark" :class="{'is-danger': errors.has('courserequest.datenschutzbp') }"></span>
                  <span class="help is-danger" v-show="errors.has('courserequest.datenschutzbp')">Bitte akzeptiere unsere Datenschutzhinweise.<br/></span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12 span12 btn-block" v-if="done === false">
                <button class="btn btn-large btn-block btn-primary" type="button" @click="submitformcourserequest()" style="background-image: linear-gradient(-60deg,#429321 0%,#B4EC51 100%) !important;border: 0px !important;">Anfragen</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </form>
  </modal>
  <modal title="" large :show.sync="showmodalshop" :value="showmodalshop" @ok="setmodalshop()" @cancel="setmodalshop()" effect="fade/zoom">
    <div slot="modal-header" class="modal-header" style="min-height: 62px;">
      <h4 class="modal-title">Gutschein bestellen</h4>
      <button type="button" class="btn btn-secondary align-right" @click="setmodalshop()">X</button>
    </div>
    <div slot="modal-body" class="modal-body" style="background-color: #eaeaea;" v-if="done === false">
      <form data-vv-scope="shop">
        <div class="form-row">
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('shop.forename') }" name="forename" aria-describedby="forenameHelp" placeholder="Vorname" v-model="dataset.forename">
            <span class="help is-danger" v-show="errors.has('shop.forename')">Bitte gib Deinen Vornamen ein.</span>
          </div>
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('shop.surname') }" name="surname" aria-describedby="surnameHelp" placeholder="Nachname" v-model="dataset.surname">
            <span class="help is-danger" v-show="errors.has('shop.surname')">Bitte gib Deinen Nachnamen ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="number" v-validate="'required|numeric'" :class="{'form-control': true, 'is-danger': errors.has('shop.telephon') }" name="telephon" aria-describedby="telephonHelp" placeholder="Telefonnummer" v-model="dataset.telephone">
            <span class="help is-danger" v-show="errors.has('shop.telephon')">Bitte gib Deine Telefonnummer ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="email" v-validate="'required|email'" :class="{'form-control': true, 'is-danger': errors.has('shop.mail') }" name="mail" aria-describedby="forenameHelp" placeholder="Email" v-model="dataset.email">
            <span class="help is-danger" v-show="errors.has('shop.mail')">Bitte gib Deine Emailadresse ein.</span>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Für wen ist der Gutschein?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="comment">Text für Gutschein</label>
                <textarea class="form-control" v-validate="'required|min:3'" rows="2" name="comment" v-model="notice"></textarea>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Welchen Wert soll der Gutschein haben?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body" :class="{ 'bg-danger': errors.has('shop.accountingchoicevoucher') }">
            <ul class="list-group">
              <li class="list-group-item" v-for="product in shopproducts" :key="product.id">
                <div class="row">
                  <div class="col-1 col-md-1">
                    <input v-if="shopmode === 'single'" type="radio" :value="product.name" v-model="accountingchoicevoucher">
                    <input v-if="shopmode === 'multiple'" type="checkbox" :value=product v-model="accountingchoicevoucherobj">
                  </div>
                  <div class="col-8 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">{{ product.name }}</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-3 col-md-3 text-right">
                    <h5>{{ product.price }} €</h5><small>inkl. MWSt.</small>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
    <div slot="modal-body" class="modal-body" v-if="done === true" style="min-height: 400px;">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="align-middle">Vielen Dank für Deine Anfrage. Wir melden uns umgehend bei Dir.</h1>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer" style="display: inline;">
      <form data-vv-scope="shop">
        <div class="container-fluid">
          <div class="row" v-if="done === false">
            <div class="col-12 col-md-12">
              <label class="checkcontainer">Hiermit erkläre ich mich mit der <strong><a href="https://www.b2-fit.de/datenschutz" target="_blank">Datenschutzerklärung</a></strong> einverstanden.
                <input name="datenschutz" id="datenschutz" type="checkbox" v-validate="'required'" value="Datenschutzakzeptiert">
                <span class="checkmark" :class="{'is-danger': errors.has('shop.datenschutz') }"></span>
                <span class="help is-danger" v-show="errors.has('shop.datenschutz')">Bitte akzeptiere unsere Datenschutzhinweise.<br/></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 span12 btn-block" v-if="done === false">
              <button class="btn btn-large btn-block btn-primary" type="button" @click="submitshopvoucher()" style="background-image: linear-gradient(-60deg,#429321 0%,#B4EC51 100%) !important;border: 0px !important;">Gutschein bestellen</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center" style="font-size: 10px; padding-top: 24px;">Powered by mycrogym.com</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
  <modal title="" large :show.sync="showvoucherrequest" :value="showvoucherrequest" @ok="setmodalvoucherrequest()" @cancel="setmodalvoucherrequest()" effect="fade/zoom">
    <div slot="modal-header" class="modal-header" style="min-height: 62px;">
      <h4 class="modal-title">Gutschein bestellen</h4>
      <button type="button" class="btn btn-secondary align-right" @click="setmodalvoucherrequest()">X</button>
    </div>
    <div slot="modal-body" class="modal-body" style="background-color: #eaeaea;" v-if="done === false" data-vv-scope="voucher">
      <form data-vv-scope="voucher">
        <div class="form-row">
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('voucher.forename') }" name="forename" aria-describedby="forenameHelp" placeholder="Vorname" v-model="dataset.forename">
            <span class="help is-danger" v-show="errors.has('voucher.forename')">Bitte gib Deinen Vornamen ein.</span>
          </div>
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('voucher.surname') }" name="surname" aria-describedby="surnameHelp" placeholder="Nachname" v-model="dataset.surname">
            <span class="help is-danger" v-show="errors.has('voucher.surname')">Bitte gib Deinen Nachnamen ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="number" v-validate="'required|numeric'" :class="{'form-control': true, 'is-danger': errors.has('voucher.telephon') }" name="telephon" aria-describedby="telephonHelp" placeholder="Telefonnummer" v-model="dataset.telephone">
            <span class="help is-danger" v-show="errors.has('voucher.telephon')">Bitte gib Deine Telefonnummer ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="email" v-validate="'required|email'" :class="{'form-control': true, 'is-danger': errors.has('voucher.mail') }" name="mail" aria-describedby="forenameHelp" placeholder="Email" v-model="dataset.email">
            <span class="help is-danger" v-show="errors.has('voucher.mail')">Bitte gib Deine Emailadresse ein.</span>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Für wen ist der Gutschein?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="comment">Text für Gutschein</label>
                <textarea class="form-control" v-validate="'required|min:3'" rows="2" name="comment" v-model="notice"></textarea>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Welchen Wert soll der Gutschein haben?</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body" :class="{ 'bg-danger': errors.has('voucher.accountingchoicevoucher') }">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="row">
                  <div class="col-1 col-md-1">
                    <input type="radio" value="eineeinheit" v-model="accountingchoicevoucher">
                  </div>
                  <div class="col-8 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">1 Einheit "Live Online Training"</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-3 col-md-3 text-right">
                    <h5>18 €</h5><small>inkl. MWSt.</small>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-1 col-md-1">
                    <input type="radio" value="fuenfeinheiten" v-model="accountingchoicevoucher">
                  </div>
                  <div class="col-8 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">5 Einheiten "Live Online Training"</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-3 col-md-3 text-right">
                    <h5>79 €</h5><small>inkl. MWSt.</small>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-1 col-md-1">
                    <input type="radio" value="zehneinheiten" v-model="accountingchoicevoucher">
                  </div>
                  <div class="col-8 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">10 Einheiten "Live Online Training"</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-3 col-md-3 text-right">
                    <h5>139 €</h5><small>inkl. MWSt.</small>
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-1 col-md-1">
                    <input type="radio" value="individualvalue" v-model="accountingchoicevoucher">
                  </div>
                  <div class="col-8 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">Gutschein im Wert von</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-3 col-md-3 text-right">
                    <h5><input type="number" min="1" name="quantity" style="width: 68px;" v-model="accountingchoicevouchervalue"> €</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
    <div slot="modal-body" class="modal-body" v-if="done === true" style="min-height: 400px;">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="align-middle">Vielen Dank für Deine Anfrage. Wir melden uns umgehend bei Dir.</h1>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer" style="display: inline;">
      <form data-vv-scope="voucher">
        <div class="container-fluid">
          <div class="row" v-if="done === false">
            <div class="col-12 col-md-12">
              <label class="checkcontainer">Hiermit erkläre ich mich mit der <strong><a href="https://www.b2-fit.de/datenschutz" target="_blank">Datenschutzerklärung</a></strong> einverstanden.
                <input name="datenschutz" id="datenschutz" type="checkbox" v-validate="'required'" value="Datenschutzakzeptiert">
                <span class="checkmark" :class="{'is-danger': errors.has('voucher.datenschutz') }"></span>
                <span class="help is-danger" v-show="errors.has('voucher.datenschutz')">Bitte akzeptiere unsere Datenschutzhinweise.<br/></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 span12 btn-block" v-if="done === false">
              <button class="btn btn-large btn-block btn-primary" type="button" @click="submitformvoucher()" style="background-image: linear-gradient(-60deg,#429321 0%,#B4EC51 100%) !important;border: 0px !important;">Gutschein bestellen</button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center" style="font-size: 10px; padding-top: 24px;">Powered by mycrogym.com</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
  <modal title="" large :show.sync="showshoppingcart" :value="showshoppingcart" effect="fade/zoom">
    <div slot="modal-header" class="modal-header" style="min-height: 62px;">
      <h4 class="modal-title">Anfrage</h4>
      <button type="button" class="btn btn-secondary align-right" @click="closemodalshoppingcart()">X</button>
    </div>
    <div slot="modal-body" class="modal-body" style="background-color: #eaeaea;" v-if="done === false" data-vv-scope="trainings">
      <form data-vv-scope="trainings">
        <div class="form-row">
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('trainings.forename') }" name="forename2" aria-describedby="forenameHelp" placeholder="Vorname" v-model="dataset.forename">
            <span class="help is-danger" v-show="errors.has('trainings.forename')">Bitte gib Deinen Vornamen ein.</span>
          </div>
          <div class="form-group col-sm-6 col-xs-12">
            <input type="text" v-validate="'required|alpha_spaces|min:2'" :class="{'form-control': true, 'is-danger': errors.has('trainings.surname') }" name="surname2" aria-describedby="surnameHelp" placeholder="Nachname" v-model="dataset.surname">
            <span class="help is-danger" v-show="errors.has('trainings.surname')">Bitte gib Deinen Nachnamen ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="number" v-validate="'required|numeric'" :class="{'form-control': true, 'is-danger': errors.has('trainings.telephon') }" name="telephon2" aria-describedby="telephonHelp" placeholder="Telefonnummer" v-model="dataset.telephone">
            <span class="help is-danger" v-show="errors.has('trainings.telephon')">Bitte gib Deine Telefonnummer ein.</span>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-sm-12">
            <input type="email" v-validate="'required|email'" :class="{'form-control': true, 'is-danger': errors.has('trainings.mail') }" name="mail2" aria-describedby="forenameHelp" placeholder="Email" v-model="dataset.email">
            <span class="help is-danger" v-show="errors.has('trainings.mail')">Bitte gib Deine Emailadresse ein.</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <h5>Folgende Kurse möchte ich buchen</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <ul class="list-group">
              <li v-for="event in orderedselectedevents" class="list-group-item">
                <div class="row">
                  <div class="col-4 col-md-2 col-sm-4">
                    <small>{{ new Date(event.datestart).formatDate('dd') }}</small><h2>{{ new Date(event.datestart).formatDate('DD') }}</h2>
                  </div>
                  <div class="col-4 col-md-8 col-sm-4">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">{{ getservicedata(event.serviceid).description }}</h5>
                    </div>
                    <div class="row">
                      <small>{{ new Date(event.datestart).formatDate('HH:mm') }} - {{ new Date(event.dateend).formatDate('HH:mm') }}</small>
                    </div>
                    <div class="row">
                      <small>{{ getlocationdata(event.locationid).city }}</small>
                    </div>
                  </div>
                  <div class="col-4 col-md-2 col-sm-4">
                    <button type="button" class="btn btn-warning align-right" @click="$store.commit('addorremoveslot',event)">X</button>
                  </div>
                </div>
              </li>
              <li class="list-group-item list-group-item-action list-group-item-info">
                <div class="row">
                  <div class="col-sm-10">
                    Anzahl Reservierungen
                  </div>
                  <div class="col-sm-2 align-center">
                    {{ selectedevents.length }}
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Zur Verrechnung möchte ich folgende Option wählen</h5>
          </div>
        </div>
        <div class="card">
          <div class="card-body" :class="{ 'bg-danger': errors.has('trainings.accountingchoice') }">
            <ul class="list-group">
              <li class="list-group-item">
                <div class="row">
                  <div class="col-4 col-md-1">
                    <input type="radio" value="bestehendeskartenkontingent" v-model="accountingchoice">
                  </div>
                  <div class="col-4 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">Aus bestehendem Kartenkontingent</h5>
                    </div>
                    <div class="row">
                      <small>Voraussetzung ist Trainingsguthaben auf einer bestehenden Karte.</small>
                    </div>
                  </div>
                  <div class="col-4 col-md-3">
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-4 col-md-1">
                    <input type="radio" value="bestehendetrainingsmitgliedschaft" v-model="accountingchoice">
                  </div>
                  <div class="col-4 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">Aus bestehender Studiomitgliedschaft</h5>
                    </div>
                    <div class="row">
                      <small>Voraussetzung ist eine aktive Studiomitgliedschaft.</small>
                    </div>
                  </div>
                  <div class="col-4 col-md-3">
                  </div>
                </div>
              </li>
              <li class="list-group-item">
                <div class="row">
                  <div class="col-4 col-md-1">
                    <input type="radio" value="einheitenerwerben" v-model="accountingchoice">
                  </div>
                  <div class="col-4 col-md-8">
                    <div class="row d-flex w-100 justify-content-between">
                      <h5 class="">Einheit/en erwerben</h5>
                    </div>
                    <div class="row">

                    </div>
                  </div>
                  <div class="col-4 col-md-3">
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <input style="display:none;" name="accountingchoice" id="accountingchoice" type="text" v-validate="'required'" v-model="accountingchoice">
        <span class="help is-danger" v-show="errors.has('trainings.accountingchoice')">Bitte geben Sie eine Option an.</span>
        <br />
        <div class="row">
          <div class="col-sm-12">
            <h5>Bemerkung</h5>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-12">
            <textarea class="form-control" rows="5" v-model="notice"></textarea>
          </div>
        </div>
      </form>
    </div>
    <div slot="modal-body" class="modal-body" v-if="done === true" style="min-height: 400px;">
      <div class="row align-items-center">
        <div class="col">
          <h1 class="align-middle">Vielen Dank für Deine Anfrage. Wir melden uns umgehend bei Dir.</h1>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer" style="display: inline;">
      <form data-vv-scope="trainings">
        <div class="container-fluid">
          <div class="row" v-if="done === false">
            <div class="col-12 col-md-12">
              <label class="checkcontainer">Hiermit erkläre ich mich mit der <strong><a href="https://www.b2-fit.de/datenschutz" target="_blank">Datenschutzerklärung</a></strong> einverstanden.
                <input name="datenschutztr" id="datenschutztr" type="checkbox" v-validate="'required'" value="Datenschutzakzeptiert">
                <span class="checkmark" :class="{'is-danger': errors.has('trainings.datenschutztr') }"></span>
                <span class="help is-danger" v-show="errors.has('trainings.datenschutztr')">Bitte akzeptiere unsere Datenschutzhinweise.<br/></span>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-12 span12 btn-block" v-if="done === false">
              <button class="btn btn-large btn-block btn-primary" type="button" @click="submitformtrainings()" style="background-image: linear-gradient(-60deg,#429321 0%,#B4EC51 100%) !important;border: 0px !important;" :disabled=loading>
                <div class="row h-100">
                  <div class="col-1 my-auto">
                    <div class="loader" v-if="loading"></div>
                  </div>
                  <div class="col-11 my-auto">
                    Buchungsanfrage verschicken
                  </div>
                </div>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p class="text-center" style="font-size: 10px; padding-top: 24px;">Powered by mycrogym.com</p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </modal>
  <div class="mgcookieconsentmobil d-sm-none d-md-none d-lg-none" v-if="showcookieconsentmobil">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-left" style="font-size: 16px;">Diese Seite nutzt Cookies</h2>
        <p class="text-left" style="font-size: 12px;">Wir nutzen Cookies um die Nutzererfahrung zu verbessern.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <button type="button" class="btn btn-success btn-block" style="font-size: 12px;" @click="allowallcookies()">Alle zulassen</button>
      </div>
      <div class="col-6">
        <button type="button" class="btn btn-outline-secondary btn-block" style="font-size: 12px;" @click="getmoreinfos()">Mehr erfahren</button>
      </div>
    </div>
  </div>
  <div class="mgcookieconsentmobilfull d-flex align-items-center d-sm-none d-md-none d-lg-none" v-if="showcookieconsent && showcookiegetmore">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="text-left" style="font-size: 16px;">Diese Seite nutzt Cookies</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="text-left" style="font-size: 12px;">Wir nutzen Cookies um die Nutzererfahrung zu verbessern. Wähle welches Cookies Du erlauben möchtest:</p>
        </div>
      </div>
      <div class="row" v-for="service in userservices">
        <div class="col-md-12">
          <label class="checkcontainer" :for=service.service style="font-size: 12px;">{{ service.service }}
            <input type="checkbox" :id=service.service :value=service.service v-model="service.status">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="row" style="margin-top:12px;">
        <div class="col-6">
          <button type="button" class="btn btn-success btn-block" style="font-size: 12px;" @click="allowallcookies()">Alle zulassen</button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-outline-secondary btn-block" style="font-size: 12px;" @click="savecookiedecision()">Speichern</button>
        </div>
      </div>
    </div>
  </div>
  <div class="mgcookieconsent d-none d-sm-block d-md-block d-lg-block" v-if="showcookieconsent">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h2 class="text-left" style="font-size: 16px;">Diese Seite nutzt Cookies</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p class="text-left" style="font-size: 12px;">Wir nutzen Cookies um die Nutzererfahrung zu verbessern. Wähle welches Cookies Du erlauben möchtest:</p>
        </div>
      </div>
      <div class="row" v-for="service in userservices">
        <div class="col-md-12">
          <label class="checkcontainer" :for=service.service style="font-size: 12px;">{{ service.service }}
            <input type="checkbox" :id=service.service :value=service.service v-model="service.status">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <div class="row" style="margin-top:12px;">
        <div class="col-md-6">
          <button type="button" class="btn btn-success btn-block" style="font-size: 12px;" @click="allowallcookies()">Alle zulassen</button>
        </div>
        <div class="col-md-6">
          <button type="button" class="btn btn-outline-secondary btn-block" style="font-size: 12px;" @click="savecookiedecision()">Speichern</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { modal } from 'vue-strap'
import { setupCalendar, DatePicker } from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import Multiselect from 'vue-multiselect'
import { mapState } from 'vuex'
setupCalendar({
  firstDayOfWeek: 2,
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'DD.MM.YYYY'],
    dayPopover: 'L'
  },
  weeks: true,
  paneWidth: 250
})
export default {
  name: 'app',
  components: {
    modal,
    setupCalendar,
    'v-date-picker': DatePicker,
    'multiselect': Multiselect,
    mapState
  },
  data () {
    return {
      orderedselectedevents: [],
      accountingchoice: '',
      accountingchoicevoucher: '',
      accountingchoicevoucherobj: [],
      accountingchoicevouchervalue: '',
      selectedproducts: [],
      modus: 'Probetrainings',
      modus2: 'Kursstart_vereinbaren',
      dataprivacy: false,
      dataset: {
        forename: '',
        surname: '',
        telephone: '',
        email: ''
      },
      location: 'Frankfurt',
      dates: [],
      trainingsobj: [],
      notice: '',
      userservices: [
        { service: 'Facebook', kind: 'cookie', status: true },
        { service: 'Google Analytics', kind: 'js', status: true }
      ],
      userservicesstatus: [],
      times: [
        { time: '8:00 - 9:00' },
        { time: '9:00 - 10:00' },
        { time: '10:00 - 11:00' },
        { time: '11:00 - 12:00' },
        { time: '14:00 - 15:00' },
        { time: '15:00 - 16:00' },
        { time: '16:00 - 17:00' },
        { time: '17:00 - 18:00' },
        { time: '18:00 - 19:00' },
        { time: '19:00 - 20:00' }
      ],
      trainings: [
        { training: "OUTDOOR PERSONAL TRAINING" },
        { training: "TRX" },
        { training: "POWER PLATE" },
        { training: "EMS" },
        { training: "RÜCKEN- UND BEWEGLICHKEITSTRAINING" },
        { training: "CARDIOFIT" },
        { training: "FIRMENFITNESS" },
        { training: "PRÄVENTIONSKURSE" },

      ],
      actions: [],
      actions2: [],
      actions3: [],
      calendars: [],
      calendarselects: [],
      templates: [],
      userAgent: [],
      scrollHeight: 0,
      stickysidebar: false,
      opacity: 0,
      stickybottombar: 0,
      done: false,
      uri: '',
      persistentnavigation: false,
      headerelement: '',
      headerbottompositioninpixel: 0,
      persistentnav: '',
      anchorlinks: '',
      anchors: [],
      sticky: '',
      loading: false
    }
  },
  created: function () {
    if (process.env.NODE_ENV === 'development') {
      this.uri = '/request'
    } else if (process.env.NODE_ENV === 'production') {
      this.uri = 'https://api.mycrogym.com/request/'
    }
    var self = this
    document.addEventListener('scroll', function () {
      self.scrollfunc()
    })
  },
  computed: {
    ...mapState({
      showmodalgeneralrequest: state => state.showmodalgeneralrequest,
      showmodalgeneralrequestmodus: state => state.showmodalgeneralrequestmodus,
      showmodalcourserequest: state => state.showmodalcourserequest,
      showmodalcourserequestname: state => state.showmodalcourserequestname,
      showmodalshop: state => state.showmodalshop,
      shopproducts: state => state.shopproducts,
      shopmode: state => state.shopmode,
      selectedevents: state => state.selectedevents,
      showshoppingcart: state => state.showmodalshoppingcart,
      showvoucherrequest: state => state.showmodalvoucherrequest,
      showstickysidebar: state => state.showstickysidebar,
      showstickynavbar: state => state.showstickynavbar,
      services: state => state.services,
      locations: state => state.locations,
      showcookieconsent: state => state.showcookieconsent,
      showcookieconsentmobil: state => state.showcookieconsentmobil,
      showcookieconsentmobilfull: state => state.showcookieconsentmobilfull,
      showcookiegetmore: state => state.showcookiegetmore
    })
  },
  mounted: function () {
    let userserviceparameter = localStorage.getItem('mgcookieconsent')
    if (userserviceparameter !== null) {
      this.$store.commit('showcookieconsent', false)
      this.$store.commit('showcookieconsentmobil', false)
      this.stickysidebar = true
      this.userservices = JSON.parse(userserviceparameter)
    } else {
      this.stickysidebar = false
      this.$store.commit('showcookieconsent', true)
      this.$store.commit('showcookieconsentmobil', true)
    }
    userserviceparameter = null
    this.scrollfunc()
    this.orderedselectedevents = JSON.parse(JSON.stringify(this.selectedevents))
    this.orderedselectedevents.sort(this.date_sort_asc)
    this.persistentnav = document.getElementById('persitentnav')
    if (typeof this.persistentnav !== 'undefined' && this.persistentnav !== null) {
      this.persistentnavigation = true
      this.anchorlinks = document.getElementsByClassName('anchorlink')
      this.headerelement = document.getElementById(this.persistentnav.dataset.navigationidname)
      this.sticky = this.persistentnav.offsetTop - this.persistentnav.getBoundingClientRect().height
      for (let i2 = 0; i2 < this.anchorlinks.length; i2++) {
        let newelement = document.createElement('a')
        newelement.innerText = this.anchorlinks[i2].dataset.description
        newelement.setAttribute('class', 'p-2 d-md-inline-block')
        newelement.setAttribute('href', '#' + this.anchorlinks[i2].name)
        this.persistentnav.getElementsByClassName("containernav")[0].appendChild(newelement)
      }
    }
  },
  beforeDestroy: function () {
    for (let i = 0; i < this.actions.length; i++) {
      this.actions[i].removeEventListener("click", function() {
      })
    }
    for (let i = 0; i < this.actions2.length; i++) {
      this.actions2[i].removeEventListener("click", function() {
      })
    }
    document.removeEventListener('scroll', function () {
    })
  },
  methods: {
    getmoreinfos: function () {
      this.$store.commit('showcookieconsent', true)
      this.$store.commit('showcookieconsentmobil', false)
      this.$store.commit('showcookiegetmore', true)
      return false
    },
    allowallcookies: function () {
      for (let i = 0; i < this.userservices.length; i++) {
        this.userservices[i].status = true
      }
      localStorage.setItem('mgcookieconsent', JSON.stringify(this.userservices))
      this.stickysidebar = true
      this.$store.commit('showcookieconsent', false)
      this.$store.commit('showcookieconsentmobil', false)
      this.$store.commit('showcookiegetmore', false)
      return false
    },
    savecookiedecision: function () {
      for (let i = 0; i < this.userservices.length; i++) {
        if (this.userservices[i].status === false) {
          console.log('cookie ' + this.userservices[i].service + ' löschen')
        }
      }
      localStorage.setItem('mgcookieconsent', JSON.stringify(this.userservices))
      this.stickysidebar = true
      this.$store.commit('showcookieconsent', false)
      this.$store.commit('showcookieconsentmobil', false)
      this.$store.commit('showcookiegetmore', false)
      return false
    },
    setmodalshoppingcart () {
      this.$store.commit('showorhideshoppingcart')
      return false
    },
    setmodalvoucherrequest () {
      this.$store.commit('showorhidevoucherrequest')
      return false
    },
    setmodalgeneralrequest (modus) {
      this.$store.commit('showorhidegeneralrequest', modus)
      return false
    },
    setmodalshop (modus) {
      this.$store.commit('showorhidemodalshop', modus)
      return false
    },
    getservicedata: function (serviceid) {
      return this.services.find(service => service.id === serviceid)
    },
    getlocationdata: function (locationid) {
      return this.locations.find(location => location.id === locationid)
    },
    date_sort_asc: function (data1, data2) {
      if (new Date(data1.datestart) > new Date(data2.datestart)) return 1
      if (new Date(data1.datestart) < new Date(data2.datestart)) return -1
      return 0
    },
    getdisableddays: function (index) {
      let object = []
      object.push('weekdays: [1, 7]')
      for (let i = 0; i < this.dates.length; i ++) {
        if (i !== index) {
        let datestring = new Date(this.dates[i].date)
        object.push(datestring)
        }
      }
      return object
    },
    mindate: function () {
      let dateobj = new Date()
      dateobj.setDate(dateobj.getDate() + 1)
      return dateobj
    },
    whatsapp () {
      window.open("https://wa.me/496966566150?text=Hallo%20liebes%20b2%20Team%2C%20ich%20w%C3%BCrde%20mich%20gerne%20%C3%BCber%20Eure%20Trainings%20informieren.%20Viele%20Gr%C3%BC%C3%9Fe")
      return false
    },
    phone () {
      window.location.href = "tel://06966566150"
      return false
    },
    mail () {
      let emailTo = 'info@b2-fit.de'
      let emailSub = 'Anfrage b2'
      let emailBody = 'Hallo liebes b2-Team'
      let text = 'mailto:'+emailTo+'?&subject='+emailSub+'?&body='+emailBody
      let win = window.open(text, 'emailWindow')
      // if (win && win.open && !win.closed) win.close()
      return false
    },
    nextdate: function () {
      let nextday = new Date()
      nextday.setDate(nextday.getDate() + 1)
      let day = nextday.getDay()
      if (day === 0) nextday.setDate(nextday.getDate() + 1)
      if (day === 6) nextday.setDate(nextday.getDate() + 2)
      if (this.dates.length > 0) {
        this.dates.sort(function (a,b) {
          return new Date(a.date) - new Date(b.date)
        })
        for (let i = 0; i < this.dates.length; i ++) {
          if (new Date(this.dates[i].date).formatDate('YYYY-MM-DD') === nextday.formatDate('YYYY-MM-DD')) {
            nextday.setDate(nextday.getDate() + 1)
            let day = nextday.getDay()
            if (day === 0) nextday.setDate(nextday.getDate() + 1)
            if (day === 6) nextday.setDate(nextday.getDate() + 2)
          }
        }
      }
      return nextday
    },
    submitform () {
      this.$validator.validateAll('request').then((result) => {
        if (result) {
          for (let i = 0; i < this.dates.length; i++) {
            this.dates[i].date = new Date(this.dates[i].date).formatDate('DD.MM.YYYY')
          }
          let payload = {}
          payload.command = 'request'
          payload.dataset = this.dataset
          payload.trainings = this.trainingsobj
          payload.dates = this.dates
          payload.modus = this.showmodalgeneralrequestmodus
          payload.location = this.location
          payload.notice = this.notice
          this.$http.post(this.uri, JSON.stringify(payload))
            .then(function (response) {
              this.done = true
              setTimeout(this.closemodal, 5000)
            }, function (reason) {
            })
        }
      })
      return false
    },
    submitformtrainings () {
      this.$validator.validateAll('trainings').then((result) => {
        if (result) {
          this.loading = true
          let payload = {}
          payload.command = 'trainings'
          payload.dataset = this.dataset
          // Events auflösen
          payload.events = []
          for (let i = 0; i < this.orderedselectedevents.length; i++) {
            let entry = {
              id: this.orderedselectedevents[i].id,
              service: this.services.find(service => service.id === this.orderedselectedevents[i].serviceid).description,
              locationname: this.locations.find(location => location.id === this.orderedselectedevents[i].locationid).name,
              date: new Date(this.orderedselectedevents[i].datestart).formatDate('DD.MM.YYYY'),
              from: new Date(this.orderedselectedevents[i].datestart).formatDate('HH:mm'),
              to: new Date(this.orderedselectedevents[i].dateend).formatDate('HH:mm')
            }
            payload.events.push(entry)
          }
          payload.accounting = this.accountingchoice
          payload.location = this.location
          payload.notice = this.notice
          this.$http.post(this.uri, JSON.stringify(payload))
            .then(function (response) {
              this.done = true
              this.loading = false
              this.$store.commit('clearcart')
              setTimeout(this.closemodalshoppingcart, 5000)
            }, function (reason) {
          })
        }
      })
      return false
    },
    submitformvoucher () {
      this.$validator.validateAll('voucher').then((result) => {
        let vouchervalue = ''
        if (this.accountingchoicevoucher === 'individualvalue') vouchervalue = this.accountingchoicevouchervalue
        if (this.accountingchoicevoucher === 'eineeinheit') vouchervalue = '18'
        if (this.accountingchoicevoucher === 'fuenfeinheiten') vouchervalue = '79'
        if (this.accountingchoicevoucher === 'zehneinheiten') vouchervalue = '139'
        if (result) {
          this.loading = true
          let payload = {}
          payload.command = 'voucher'
          payload.dataset = this.dataset
          payload.accountingchoicevoucher = this.accountingchoicevoucher
          payload.accountingchoicevouchervalue = vouchervalue
          payload.notice = this.notice
          payload.location = this.location
          this.$http.post(this.uri, JSON.stringify(payload))
            .then(function (response) {
              this.done = true
              this.loading = false
              // this.$store.commit('clearcart')
              setTimeout(this.closemodalvoucher, 5000)
            }, function (reason) {
          })
        }
      })
      return false
    },
    submitshopvoucher () {
      this.$validator.validateAll('shop').then((result) => {
        if (result) {
          let payload = {}
          payload.command = 'voucher'
          payload.dataset = this.dataset
          payload.notice = this.notice
          payload.location = this.location
          if (this.shopmode === 'single') {
            for (let i = 0; i < this.shopproducts.length; i++) {
              if (this.shopproducts[i].name === this.accountingchoicevoucher) payload.accountingchoicevouchervalue = this.shopproducts[i].price
            }
            payload.accountingchoicevoucher = this.accountingchoicevoucher
          } else if (this.shopmode === 'multiple') {
            payload.accountingchoicevoucher = JSON.stringify(this.accountingchoicevoucher)
          }
          this.$http.post(this.uri, JSON.stringify(payload))
            .then(function (response) {
              this.done = true
              this.loading = false
              // this.$store.commit('clearcart')
              setTimeout(this.closemodalvoucher, 5000)
            }, function (reason) {
          })
        }
      })
      return false
    },
    submitformcourserequest () {
      this.$validator.validateAll('courserequest').then((result) => {
        this.loading = true
        if (result) {
          let payload = {}
          payload.command = 'courserequest'
          payload.dataset = this.dataset
          payload.modus = this.modus2
          payload.coursename = this.showmodalcourserequestname
          payload.notice = this.notice
          payload.location = this.location
          this.$http.post(this.uri, JSON.stringify(payload))
            .then(function (response) {
              this.done = true
              this.loading = false
              // this.$store.commit('clearcart')
              setTimeout(this.closemodalcourserequest, 5000)
            }, function (reason) {
          })
        }
      })
      return false
    },
    scrollfunc: function () {
      this.scrollHeight = window.pageYOffset
      let stickyhorizontalnavbottom = document.getElementById('stickyhorizontalnav').getBoundingClientRect().bottom
      if (this.anchorlinks.length > 0) {
        for (let i = 0; i < this.anchorlinks.length; i++) {
          if (window.pageYOffset < this.anchorlinks[0].getBoundingClientRect().top + window.scrollY - stickyhorizontalnavbottom) {
            let elems = document.getElementById('stickyhorizontalnav').childNodes
            for (let i2 = 0; i2 < elems.length; i2++) {
              if (elems[i2].classList.contains("active")) elems[i2].classList.remove("active")
            }
          }
          if ((i + 1) < this.anchorlinks.length) {
            if (window.pageYOffset >= this.anchorlinks[i].getBoundingClientRect().top + window.scrollY && window.pageYOffset < this.anchorlinks[i + 1].getBoundingClientRect().top + window.scrollY - stickyhorizontalnavbottom) {
              let elems = document.getElementById('stickyhorizontalnav').childNodes
              for (let i2 = 0; i2 < elems.length; i2++) {
                if (elems[i2].text === this.anchorlinks[i].dataset.description) {
                  if (!elems[i2].classList.contains("active"))  elems[i2].classList.add("active")
                } else {
                  if (elems[i2].classList.contains("active")) elems[i2].classList.remove("active")
                }
              }
            }
          } else {
            if (window.pageYOffset >= this.anchorlinks[i].getBoundingClientRect().top + window.scrollY) {
              let elems = document.getElementById('stickyhorizontalnav').childNodes
              for (let i2 = 0; i2 < elems.length; i2++) {
                if (elems[i2].text === this.anchorlinks[i].dataset.description) {
                  if (!elems[i2].classList.contains("active")) elems[i2].classList.add("active")
                } else {
                  if (elems[i2].classList.contains("active")) elems[i2].classList.remove("active")
                }
              }
            }
          }
        }
      }
      if (typeof this.headerelement === 'object') {
        if (this.scrollHeight + window.scrollY > this.headerelement.getBoundingClientRect().bottom) {
          if (this.stickysidebar !== true && this.showstickysidebar === true) {
            this.stickysidebar = true
            if (this.persistentnavigation === true) {
              this.persistentnav.classList.add("persitant-sticky-top")
              this.persistentnav.style.top = this.headerelement.getBoundingClientRect().bottom + "px"
            }
          }
        } else {
          if (this.stickysidebar !== false) {
            this.stickysidebar = false
            if (this.persistentnavigation === true) {
              this.persistentnav.classList.remove("persitant-sticky-top")
            }
          }
        }
      }
    },
    adddate () {
      this.dates.push({ date: this.nextdate(), times: [] })
    },
    deletedate (i) {
      this.dates.splice(i,1)
    },
    closemodal () {
      this.$store.commit('showorhidegeneralrequest', this.modus)
      this.done = false
      this.dataset.forename = ''
      this.dataset.surname = ''
      this.dataset.telephone = ''
      this.dataset.email = ''
      this.dates = []
      this.trainingsobj = []
    },
    closemodalcourserequest () {
      this.$store.commit('showorhidecourserequest', this.modus)
      this.done = false
      this.dataset.forename = ''
      this.dataset.surname = ''
      this.dataset.telephone = ''
      this.dataset.email = ''
      this.dates = []
      this.trainingsobj = []
    },
    closemodalshoppingcart () {
      this.setmodalshoppingcart()
      this.done = false
      this.dataset.forename = ''
      this.dataset.surname = ''
      this.dataset.telephone = ''
      this.dataset.email = ''
      this.modus = ''
      this.events = []
      this.accountingchoice = ''
      this.trainingsobj = []
      return false
    },
    closemodalvoucher () {
      this.setmodalvoucherrequest()
      this.done = false
      this.dataset.forename = ''
      this.dataset.surname = ''
      this.dataset.telephone = ''
      this.dataset.email = ''
      this.modus = ''
      this.events = []
      this.accountingchoicevoucher = ''
      return false
    }
  },
  watch: {
    selectedevents: function (data) {
      this.orderedselectedevents = JSON.parse(JSON.stringify(data))
      this.orderedselectedevents.sort(this.date_sort_asc)
    }
  }
}
</script>
<style>
.accordion {
width: 100%;
overflow: hidden;
padding: 48px;
}
.accordion ul {
width: 100%;
display: table;
table-layout: fixed;
margin: 0;
padding: 0;
}
.accordion ul:hover li { width: 6%; }

.accordion ul:hover li:hover { width: 70%; }

.accordion ul:hover li:hover a {  }

.accordion ul:hover li:hover a * {
opacity: 1;
-webkit-transform: translateX(0);
transform: translateX(0);
}
@media screen and (max-width: 600px) {

.accordion { height: auto; }

.accordion ul li,
.accordion ul li:hover,
.accordion ul:hover li,
.accordion ul:hover li:hover {
position: relative;
display: table;
table-layout: fixed;
width: 100%;
-webkit-transition: none;
transition: none;
}

}

.accordion ul li {
display: table-cell;
vertical-align: bottom;
position: relative;
width: 16.666%;
height: 450px;
background-size: cover;
background-repeat: none;
transition: all 800ms ease;
left: 24px;
}

.accordion ul li div {
display: block;
overflow: hidden;
width: 100%;
padding: 12px;
}

.accordion ul li div h2 {
margin-top: 300px;
font-size: 24px;
color: #ffffff;
text-shadow: 2px 2px 2px #e30613;
}
.accordion ul:hover li div h2 {
  margin-top: 0px;
  left: 6px;
  writing-mode: vertical-rl;
  -webkit-text-orientation: mixed;
  text-orientation: mixed;
}
.accordion ul li:hover div h2 {
  writing-mode: horizontal-tb;
  font-size: 32px;
}

.accordion ul li div a {
display: block;
width: 100%;
position: relative;
z-index: 3;
vertical-align: bottom;
padding: 15px 20px;
box-sizing: border-box;
color: #fff;
text-decoration: none;
font-family: Open Sans, sans-serif;
transition: all 400ms ease;
}

.accordion ul li div a * {
opacity: 0;
margin: 0;
width: 100%;
text-overflow: ellipsis;
position: relative;
z-index: 5;
white-space: nowrap;
overflow: hidden;
-webkit-transform: translateX(-20px);
transform: translateX(-20px);
-webkit-transition: all 800ms ease;
transition: all 800ms ease;
}

.accordion ul li div a h2 {
font-family: Montserrat, sans-serif;
text-overflow: clip;
font-size: 10px;
text-transform: uppercase;
margin: 12px;
top: 160px;
}

.accordion ul li div a p {
top: 160px;
font-size: 13.5px;
}
.accordion ul li:nth-child(1) { background-image: url(https://www.b2-fit.de/images/personal_training.jpg); background-size: cover; background-position: 20% 50%;}
.accordion ul li:nth-child(1):hover { background-position: 50% 50%; }
.accordion ul li:nth-child(2) { background-image: url(https://www.b2-fit.de/images/HeroTeaserWirGehenOnline.jpg); background-size: cover; background-position: 30% 50%; }
.accordion ul li:nth-child(2):hover { background-position: 50% 50%; }
.accordion ul li:nth-child(3) { background-image: url(https://www.b2-fit.de/images/hiit.jpg); background-size: cover; background-position: 20% 70%;}
.accordion ul li:nth-child(3):hover { background-position: 50% 50%; }
.accordion ul li:nth-child(4) { background-image: url(https://www.b2-fit.de/images/440999-five-20140918-0128.jpg); background-size: cover; background-position: 60% 50%;}
.accordion ul li:nth-child(4):hover { background-position: 50% 50%; }
.accordion ul li:nth-child(5) { background-image: url(https://unsplash.it/650/350?image=672); background-size: cover; background-position-x: center; }
.accordion ul li:nth-child(5):hover { background-position: 50% 50%; }
.accordion ul li:nth-child(6) { background-image: url(https://unsplash.it/650/350?image=672); background-size: cover; background-position-x: center; }
.accordion ul li:nth-child(6):hover { background-position: 50% 50%; }
</style>
